import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactSelect from 'react-select';
import lo from 'lodash'

import { Label } from 'atoms/Texts'
import { setGlobalSite, setGlobalCompany } from 'Redux/actions/GlobalActions';
import { Container, Field, selectStyle } from './styles'

const CompanyFilter = ({
  userDetail,
  site,
  company,
  setGlobalSite,
  setGlobalCompany
}) => {
  const sites = userDetail
    ? lo.uniqBy(userDetail.allowedCompanies.map(c => c.workLocation), l => l.id)
    : []
  const companies = userDetail && site ? userDetail.allowedCompanies.filter(c => c.workLocation.id === site.id) : []

  return (
    <Container>
      <Field>
        <Label lineheight={'14px'} mb={'4px'} size={'12px'}>
          Site
        </Label>
        <ReactSelect
          styles={selectStyle}
          placeholder="Select site"
          getOptionValue={({ id }) => id}
          getOptionLabel={({ name }) => name}
          options={sites}
          value={site}
          onChange={setGlobalSite}
        />
      </Field>
      <Field>
        <Label lineheight={'14px'} mb={'4px'} size={'12px'}>
          Company
        </Label>
        <ReactSelect
          styles={selectStyle}
          placeholder="Select company"
          getOptionValue={({ id }) => id}
          getOptionLabel={({ name }) => name}
          options={companies}
          value={company}
          onChange={setGlobalCompany}
        />
      </Field>
    </Container>
  )
}

const mapStateToProps = state => {
  return {
    userDetail: state.userLogin ? state.userLogin.userDetail : null,
    site: state.globals.site,
    company: state.globals.company
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setGlobalSite,
      setGlobalCompany
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyFilter)
